import React from 'react';

const SendVoice = () => {
    return (
        <svg width={11.197} height={11.404} viewBox="0 0 11.197 11.404">
            <path
                d="M3.687 7.08L.5 3.894 3.687.707"
                fill="none"
                stroke="#8F99DC"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
            <path
                d="M10.7 10.904V6.443a2.549 2.549 0 00-2.552-2.549H.5"
                fill="none"
                stroke="#8F99DC"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
        </svg>
    );
};

export default SendVoice;
